import api from "./api";

export const changeAdminPassword = async (payload: { currentPassword: string; newPassword: string }) => {
  const { data } = await api.patch("/admin/v1/me/password", payload);
  return data;
};

export const getAdminProfile = async () => {
  const { data } = await api.get("/admin/v1/me/profile");
  return data;
};
